import {FormConfig} from '../../../form/form.config';
import {FormModel} from '../../../form/form.model.abstract';
import {Validators} from '@angular/forms';
import {ValidationService} from '../../../services/validation.service';
import {FormModelText} from '../../../form/form.model.text';
import {FormModelTextSelect} from '../../../form/form.model.textselect';

/**
 * Configuration for the input of electricity price on the result page of the stromcheck.
 * @inheritDoc
 */
export class SavingsForm extends FormConfig {
  protected fields: FormModel[] = [
    new FormModelTextSelect('grundpreis_euro_monat', 'grundpreis_euro_monat_einheit',  [Validators.required, ValidationService.greaterZero], ['eur_monat', 'eur_jahr'], [], false, 'number'),
    new FormModelText('arbeitspreis_cent_kwh',  [Validators.required, ValidationService.greaterZero], 'ct_kwh', null, false, 'number')
  ];

  protected groups: any;

}
